// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"f5-z"};